import { create } from 'zustand';
import dayjs from 'dayjs';
import SRCAlarmsAndAlertsBaobabTemplate from '@data/SRCToastPositionTemplates';
import { persist } from 'zustand/middleware';
// @ts-ignore
import parsedAccommodationPriceLists from '../controllers/accommodationPriceLists';
import { produce } from 'immer';
import { RoomInfoModel } from '@common/modelDefinition';
import { devtools } from 'zustand/middleware';

interface StoreActions {
    setNestedProperty: (path: string[], value: any, pkName?: string) => void;
    deleteItem: (path: string[], pkeyName: string, pkValue: any) => any;
    getItem: (path: string[], pkeyName: string, pkValue: any) => any;
    addItem: (path: string[], newItem: any) => any;
}

interface StoreState {
    pageTitle: any;
    pagePath: any;
    pkeyMap: any;
    SRCEnums: any; //contains all relevant SRC enumerators
    model: any;
    modalData: any;
    authTokenInfo: any; //it is an object containing token and user informations. it is obtained on logon!
    modelForms: any;
    SRCAlarmsAndAlerts: any;
    socketConnection: any;
    uiStates: any;
    about: any;
    otherSettings: any;
    IOTatewayIntegration: any;
    locale: any;
    defaultCurrency: any;
    enableUsingHologicWithBMS: any;
    hiddenDocumentColumns: any;
    offlineThermalPrinterInfo: any;
    companyInfo: any;
    licence: any;
    alarmInterpreter: any;
    invoicingSettings: any;
    fiscal: any;
    version: any;
    state: any;
    keycloak: any;
    monkeys: any;
    map: any;
    BMS: any;
    BMSUuid: string[];
    broadcastFailedThermostatData: any[];
    broadcastFailedIOConfigData: any[];
    broadcastInProgress: boolean;
    onlineReception: any;
}

var parseRoomInfos = (roomInfoDataSet: RoomInfoModel[], SRCEnums: any) => {
    let parsedRoomInfo: RoomInfoModel[] = [];
    roomInfoDataSet?.forEach((r: RoomInfoModel) => {
        let tmp: any = { ...r };
        if (r.SRCSettings) {
            tmp.SRCSettings = JSON.parse(r.SRCSettings);
        }
        if (r.params) {
            tmp.params = JSON.parse(r.params);
        }

        tmp.tags =
            r.tags && typeof r.tags === 'string'
                ? r.tags.split(';')?.map((s: any) => {
                      return s.trim();
                  })
                : [];
        parsedRoomInfo.push(tmp);
    });
    return parsedRoomInfo;
};

const defaultUiStates = {
    accommodationPriceListStack: {
        timelineYearsCount: 2, //or 2 - better always 1
        startFromYear: new Date().getFullYear(), //new Date(`${new Date().getFullYear()}`) //current or the next one....
    },
    dashboard: {
        showFromToFilter: false,
        showComponents: ['timeline', 'sidebar_dailyInfo'],
        tagsFilter: [],
    },
    reservationAdministration: {
        from: dayjs().add(-1, 'month').valueOf(),
        to: dayjs().add(1, 'month').valueOf(),
    },
    columnsNumber: 2,
    showTemperaturesInHWView:false,
    financialReport: {
        from: new Date(),
        to: new Date(),
    },
}

const useStore = create(
    devtools(
        persist<StoreState & StoreActions>(
            (set: any, get: any) => ({
                pageTitle: null,
                // monkeys,
                pagePath: null,

                pkeyMap: {},
                SRCEnums: {}, //contains all relevant SRC enumerators
                model: {
                    //WARNING: Do not supply the same models in whole and partial part. baobabFunnel would broke
                    RoomInfo: [],
                    SmartRoomController: [],
                    SRCProxy: [],
                    DoorAccessPoint: [],
                    WhiteList: [],
                    Reservation: [],
                    Tax: [],
                    AccommodationPriceList: [],
                    Currency: [],
                    RoomAttribute: [],
                    SosResponse: [],
                    CleaningStatus: [],
                    RoomEventTicket: [], //getActiveRoomEventTickets
                    RequiredVisaMap: [],
                    PosTerminal: [],
                    Customer: [], //used rarely - only for condo mode for now
                    CondoOwner: [],
                    DocumentScan: [],
                    FeatureFlag: [],
                    CleaningStatusHeader: [], // include CleaningStatuses, RoomInfo, Maid1, Maid2, Maid3 - initialy get only today
                    Role: [],
                    PosDisplayConfig: [],
                    ChannelManagerMap: [],
                    PersistentNotificationSystem: [],
                    TaskManagementHeader: {},
                    TaskManagementItem: [],
                    BMSNode: [],
                    BMSNodeHWModule: [],
                    LoyaltyProgram: [],
                    CisuGuestRegistration: [],
                    OnlineReceptionReservation: [],
                },
                modalData: {
                    display: false,
                    width: '', //modal-sm || modal-lg || modal-xl
                    header: 'Modal window title',
                    // content: null, //it may be an react class instance
                    showBottomCloseButton: false,
                    params: {}, //modal params used optionaly by modal specific modal internals
                },
                authTokenInfo: null, //it is an object containing token and user informations. it is obtained on logon!
                modelForms: {},
                SRCAlarmsAndAlerts: SRCAlarmsAndAlertsBaobabTemplate,
                socketConnection: {
                    showConnectingScreen: true,
                    connectingMessage: 'ESTABLISHING SERVER CONNECTION',
                    heading: '...',
                },
                uiStates: defaultUiStates,
                about: {
                    adminUsersCount: 0, //MORA BITI 0 S RAZLOGOM. Zbog prve instalacije!!!!
                },
                otherSettings: null,
                IOTatewayIntegration: null,
                locale: null,
                defaultCurrency: null,
                enableUsingHologicWithBMS: null,
                hiddenDocumentColumns: null,
                offlineThermalPrinterInfo: null,
                companyInfo: null,
                onlineReception: null,
                licence: null,
                alarmInterpreter: null,
                invoicingSettings: null,
                fiscal: {
                    softwareFiscal: null,
                    fiscalGeneralSettings: null,
                    // registerENU: null,
                },
                cisuStats: null as null | { pending: number; waitingForData: number; needsCheckout: number; errors: number },
                BMS: {},
                BMSUuid: [],
                broadcastFailedThermostatData: [],
                broadcastFailedIOConfigData: [],
                broadcastInProgress: false,
                version: {
                    version: 'xxx',
                    DOCKER_ENV: false,
                },
                state: {
                    userPermissions: {
                        models: null,
                        features: null,
                        dashboardRoute: '/',
                        fixedRoute: '',
                        externalDashboardRoute: '',
                        externalFixedRoute: '',
                    },
                    globalLoading: 0,
                    selectedPosTerminalId: null,
                    posTerminal: {
                        //samo za potrebe sučelja pos terminala
                        invoice: {}, //ovo je povratna informacija sa backend invoice controlera
                        invoiceItems: [], //ovo je povratna ifnormacija sa backend invoice controlera
                        filteredItems: null, //ovdje ću stavljati rezultate filtriranje artiakala koje trebam priakzati u glavnom prozoru
                        activeItemsSelection: [], //ovdje je lista trenutno odabranih stavki od kojih se sastavlja pending račun (key value par) key je posItemId, value je količina
                        previousInvoices: [], //lista prethodno izdanih računa za taj terminal
                    },
                    checkoutInvoice: {
                        //za izradu računa - samo jedan checkout na jednom računalu
                        invoicePreview: {
                            invoice: {},
                            invoiceItems: [],
                        },
                        invoice: {},
                        invoiceItems: [],
                        advanceInvoices: [], //vezane uz rezervaciju na checkoutu
                        proformaInvoices: [], //vezane uz rezervaciju na checkoutu
                        stornoInvoices: [], //vezane uz rezervaciju na checkoutu
                        groupReservationsArray: [],
                        reservation: null,
                        availableForAdvancePayment: 0,
                        posTerminalInvoices: [],
                        checkoutDateMismatchs: [],
                        genuineInvoices: [], //vezane uz rezervaciju na checkoutu
                        subsequentConsumption: false, // naknadna potrošnja
                        stayoverOverlap: { overlapReservations: [], option: null, type: null },
                        minibarInvoices: [],
                        invoiceStornoPreview: null,
                        accommodationInvoice: null,
                        loyaltyProgram: null,
                    },
                    groupRes: {
                        //za izradu grupnih rezervacija u formi grupnih rezervacija
                        groupReservation: {},
                        reservations: [],
                    },
                    reservationForm2: {
                        activeReservationIndex: 0,
                        reservations: [],
                        groupReservation: {},
                        invalidVisaIds: [],
                        reloadUuid: null,
                        selfCheckInInfo: null,
                        selectedReservationIndex: 0,
                        editedGroupReservationIds: [],
                    },
                    invoicePresenter: {
                        invoice: {},
                        refInvoice: null,
                        invoicePreview: {
                            invoice: {},
                            invoiceItems: [],
                        },
                        groupReservationsArray: [],
                        stornoInvoices: [],
                        groupInvoiceDetails: {},
                        padding: 1,
                    },
                    generalSettings: {
                        //za settingse
                    },
                    householdPlanForSelectedMaid: {},
                    updatedCleaningStatuses: [],
                    permissions: [],
                    rolePermissions: [],
                },
                keycloak: {
                    authenticated: false,
                },
                majmun: 'početak',

                monkeys: {
                    parsedRoomInfo: () => {
                        const roomInfo = get().model?.RoomInfo;
                        const SRCEnums = get()?.SRCEnums;
                        return parseRoomInfos(roomInfo, SRCEnums);
                    },
                    parsedAccommodationPriceLists: () => {
                        const accommodationPriceLists = get().model.AccommodationPriceList;
                        const timelineYearsCount = get().uiStates.accommodationPriceListStack.timelineYearsCount;
                        const startFromYear = get().uiStates.accommodationPriceListStack.startFromYear;

                        return parsedAccommodationPriceLists(
                            accommodationPriceLists,
                            startFromYear,
                            timelineYearsCount
                        );
                    },
                    parsedAndTagedRoomInfo: () => {
                        const roomInfo = get().model.RoomInfo;
                        const SRCEnums = get().SRCEnums;

                        let parsedData = parseRoomInfos(roomInfo, SRCEnums);
                        let response = [];
                        // 1. Izvući 'tags' nizove i spojiti ih u jedan niz (flatten)
                        const allTags = parsedData
                            .map((item) => item.tags) // niz nizova
                            .flat(); // flatten na jednu razinu

                        // 2. Ukloniti duplikate
                        const tags = [...new Set(allTags)];
                        tags.forEach((tag: any) => {
                            response.push({
                                tag,
                                rooms: parsedData?.filter((p: any) => {
                                    return p.tags?.includes(tag);
                                }),
                            });
                        });
                        response.push({
                            tag: null,
                            rooms: parsedData?.filter((p: any) => {
                                return p.tags.length === 0;
                            }),
                        });
                        const sorted = [...response].sort((a, b) => b.rooms.length - a.rooms.length);
                        return sorted;
                    },
                    roomTags: () => {
                        const roomInfo = get().model.RoomInfo;
                        const SRCEnums = get().SRCEnums;
                        let parsedData = parseRoomInfos(roomInfo, SRCEnums);
                        // 1. Izvući 'tags' nizove i spojiti ih u jedan niz (flatten)
                        const allTags = parsedData
                            .map((item) => item.tags) // niz nizova
                            .flat(); // flatten na jednu razinu

                        // 2. Ukloniti duplikate
                        const tags = [...new Set(allTags)];
                        return tags;
                    },
                    filteredAccommodationPriceLists: () => {
                        const accommodationPriceLists = get().model.AccommodationPriceList;
                        const filterAccommodationPriceLists = accommodationPriceLists.filter((acc: any) => {
                            return !acc.condoPricelist && acc.isActive && !acc.isDeleted;
                        });
                        return filterAccommodationPriceLists;
                    },
                },

                map: {
                    RoomInfo: () => {
                        const RoomInfo = get().model.RoomInfo;
                        const res: any = {};
                        RoomInfo.forEach((p: any) => {
                            res[p.id] = p;
                        });
                        return res;
                    },
                },

                setNestedProperty: (path: any, value: any, pkName = undefined) => {
                    set(
                        produce((draftState) => {
                            let currentState: any = draftState;
                            // Traverse the path until the second-to-last element
                            for (let i = 0; i < path.length - 1; i++) {
                                currentState = currentState[path[i]];
                                if (!currentState) return; // Exit early if any intermediate state is undefined
                            }

                            // Replace the object with the specified ID if key is provided
                            if (pkName) {
                                const index = currentState?.[path?.[path?.length - 1]]?.findIndex(
                                    (obj: any) => obj[pkName] === value[pkName]
                                );
                                if (index !== -1) {
                                    currentState[path[path.length - 1]][index] = value;
                                }
                            } else {
                                // Set the value for the property
                                currentState[path[path.length - 1]] = value;
                            }
                        })
                    );
                },

                deleteItem: (path: any, pkeyName: any, pkValue: any) => {
                    set((state: any) => {
                        return produce(state, (draftState: any) => {
                            if (pkeyName) {
                                function get(obj: any, pathArray: any[]) {
                                    return pathArray.reduce(
                                        (acc, key) => (acc != null && acc[key] !== undefined ? acc[key] : undefined),
                                        obj
                                    );
                                }

                                const array = get(draftState, path);
                                const index = array ? array.findIndex((item: any) => item[pkeyName] === pkValue) : -1;

                                if (index !== -1) {
                                    array.splice(index, 1); // Remove the item from the array
                                }
                            }
                        });
                    });
                },

                getItem: (path: any, pkeyName: any, pkValue: any) => {
                    function getByPath(obj: any, path: string) {
                        return path.split('.').reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
                    }

                    function findIndexByKeyValue(array: any[], key: any, value: any) {
                        if (!Array.isArray(array)) return -1;
                        return array.findIndex((item) => item[key] === value);
                    }

                    const array = getByPath(get(), path.join('.'));
                    const index = findIndexByKeyValue(array, pkeyName, pkValue);
                    if (index !== -1) {
                        return array[index];
                    }
                },

                addItem: (path: any, newItem: any) => {
                    set((state: any) => {
                        function getByPath(obj: any, path: any, defaultValue: any) {
                            const result = path.reduce(
                                (acc: any, key: any) => (acc != null ? acc[key] : undefined),
                                obj
                            );
                            return result === undefined ? defaultValue : result;
                        }

                        // set funkcija koja postavlja vrijednost na putanji u objektu
                        function setByPath(obj: any, path: any, value: any) {
                            let current = obj;
                            for (let i = 0; i < path.length; i++) {
                                const key = path[i];
                                if (i === path.length - 1) {
                                    current[key] = value;
                                } else {
                                    if (current[key] == null || typeof current[key] !== 'object') {
                                        current[key] = {};
                                    }
                                    current = current[key];
                                }
                            }
                        }

                        // Korištenje unutar produce
                        return produce(state, (draftState: any) => {
                            const existingArray = getByPath(draftState, path, []);
                            console.log('state:', state)
                            console.log('draftState:', draftState)
                            console.log('existingArray:', existingArray)
                            console.log('newItem:', newItem)
                            existingArray.push(newItem);
                            setByPath(draftState, path, existingArray);
                        });
                    });
                },
            }),
            {
                name: 'hologic-storage',
                //@ts-ignore
                partialize: (state: any) => ({
                    //ovo ispod se kesira
                    // majmun: state.majmun,
                    authTokenInfo: state.authTokenInfo,
                    locale: state.locale,
                    licence: state.licence,
                    keycloak: state.keycloak,
                    uiStates:{...defaultUiStates, columnsNumber:state.uiStates?.columnsNumber, showTemperaturesInHWView:state.uiStates?.showTemperaturesInHWView}
                }),
            }
        )
    )
);

export default useStore;
